import { render, staticRenderFns } from "./AutobuyerToggles.vue?vue&type=template&id=0148372a&scoped=true&"
import script from "./AutobuyerToggles.vue?vue&type=script&lang=js&"
export * from "./AutobuyerToggles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148372a",
  null
  
)

export default component.exports